export enum Language {
  SPANISH = 'es',
  ENGLISH = 'gb',
}
